import React, { useState } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";
import "../committee.css"; // Import the CSS file

const SCST = () => {
  const [selectedTab, setSelectedTab] = useState("committee");

  const rows = [
    {
      id: 1,
      name: "Dr. P. Eswaramoorthi",
      designation: "Principal",
      position: "Chairman",
      mobile: "7708069402",
    },
    {
      id: 2,
      name: "Mr. G. Naveen Karthikeyan",
      designation: "Assistant Professor",
      position: "Internal Member",
      mobile: "7305023081",
    },
    {
      id: 3,
      name: "Mr. R. Muruganantham",
      designation: "Assistant Professor",
      position: "Internal Member",
      mobile: "8220755999",
    },
    {
      id: 4,
      name: "Dr. B. Gowtham",
      designation: "Associate Professor",
      position: "Internal Member",
      mobile: "9790162745",
    },
    {
      id: 5,
      name: "Mr. K. Rajiv Gandhi",
      designation: "Assistant Professor",
      position: "Internal Member",
      mobile: "6380545998",
    },
    {
      id: 6,
      name: "Dr. K. Kalimuthu",
      designation: "Assistant Professor",
      position: "Internal Member",
      mobile: "9629737238",
    },
  ];

  const handlePDFClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/SC _ST_MINUTES_OF_MEETING.pdf`,
      "_blank"
    );
  };
  return (
    <>
      <Header />
      <div className="antiragging-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1} // Add spacing between buttons
            sx={{
              // Responsive styling
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={selectedTab === "committee" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("committee")}
              style={{
                width: "100%",
                color: selectedTab === "committee" ? "#FFF" : "#000",
                borderColor: selectedTab === "committee" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              SC/ST Committee
            </Button>
            <Button
              variant={selectedTab === "mom" ? "contained" : "outlined"}
              onClick={handlePDFClick}
              style={{
                width: "100%",
                color: selectedTab === "mom" ? "#FFF" : "#000",
                borderColor: selectedTab === "mom" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Minutes Of Meeting
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            <h2>{selectedTab === "committee" ? "SC/ST Committee" : "mom"}</h2>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Designation
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Position
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Mobile Number
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(selectedTab === "committee"
                    ? rows
                    : selectedTab === "mom"
                  ).map((row, index) => (
                    <TableRow
                      key={row.id}
                      style={{
                        backgroundColor: index % 2 === 0 ? "white" : "#f1f8e9",
                      }}
                    >
                      <TableCell>{row.id}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.designation}</TableCell>
                      <TableCell>{row.position}</TableCell>
                      <TableCell>{row.mobile}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default SCST;
